module.exports = __webpack_public_path__ + "static/icons/icon-map--chile-f154847fb222c1faadb05a3d9585ce91.svg";